import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "count-bubble"
}
const _hoisted_2 = { class: "name" }
const _hoisted_3 = {
  key: 0,
  class: "title"
}
const _hoisted_4 = {
  key: 1,
  class: "subtitle"
}
const _hoisted_5 = {
  key: 1,
  class: "overlay top-left fill-block"
}

import { computed } from 'vue';

import NcCounterBubble from '@nextcloud/vue/components/NcCounterBubble';
import XImg from '@components/frame/XImg.vue';

import errorsvg from '@assets/error.svg';
import plussvg from '@assets/plus.svg';

import * as nativex from '@native';
import * as dav from '@services/dav';

import type { ICluster } from '@typings';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'Cluster',
},
  __name: 'Cluster',
  props: {
    data: {},
    link: { type: Boolean, default: true },
    counters: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const props = __props;

const emit = __emit;

const previewUrl = computed(() => {
  if (placeholder.value) return String();
  if (error.value) return errorsvg;
  if (plus.value) return plussvg;
  return dav.getClusterPreview(props.data);
});

const title = computed(() => {
  return props.data.display_name || props.data.name;
});

const subtitle = computed(() => {
  if (dav.clusterIs.album(props.data)) {
    return dav.getAlbumSubtitle(props.data);
  }

  return String();
});

const plus = computed(() => {
  return props.data.cluster_type === 'plus';
});

/** Target URL to navigate to */
const target = computed(() => {
  if (!props.link || plus.value) return {};
  return dav.getClusterLinkTarget(props.data);
});

const error = computed(() => {
  return !!props.data.previewError || (dav.clusterIs.album(props.data) && props.data.last_added_photo <= 0);
});

const placeholder = computed(() => {
  return props.data.cluster_type === 'placeholder';
});

const imgOuterStyle = computed(() => {
  const idx = props.data.cluster_id as number;
  return placeholder.value ? { animationDelay: `${idx * 0.1}s` } : {};
});

function failed() {
  props.data.previewError = true;
}

function click() {
  emit('click', props.data);
}

function clickPreview() {
  nativex.playTouchSound();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.link && !placeholder.value ? 'router-link' : 'div'), {
    draggable: "false",
    tabindex: placeholder.value ? -1 : 1,
    "aria-label": title.value,
    class: _normalizeClass(["cluster fill-block", { error: error.value, placeholder: placeholder.value }]),
    to: target.value,
    onClick: click
  }, {
    default: _withCtx(() => [
      (__props.counters && __props.data.count)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(NcCounterBubble), {
              count: __props.data.count
            }, null, 8, ["count"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (title.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(title.value), 1))
          : _createCommentVNode("", true),
        (subtitle.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(subtitle.value), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "previews fill-block",
        ref: "previews",
        onClick: clickPreview
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["img-outer", { plus: plus.value, 'ph-shimmer': placeholder.value }]),
          style: _normalizeStyle(imgOuterStyle.value)
        }, [
          (previewUrl.value)
            ? (_openBlock(), _createBlock(XImg, {
                draggable: "false",
                class: "fill-block",
                key: __props.data.cluster_id,
                src: previewUrl.value,
                "svg-tag": plus.value,
                onError: failed
              }, null, 8, ["src", "svg-tag"]))
            : _createCommentVNode("", true),
          (title.value || subtitle.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true)
        ], 6)
      ], 512)
    ]),
    _: 1
  }, 8, ["tabindex", "aria-label", "class", "to"]))
}
}

})